/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ul[_ngcontent-%COMP%]{padding-top:10px}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding-top:5px;font-weight:700}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding-top:0;padding-bottom:10px;font-weight:400}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding-left:10px;font-weight:400}"];
export { styles as styles };
